// import bicepsSvgBlue from '../../../../../assets/biceps-blue.svg';
// import bicepsSvgGray from '../../../../../assets/biceps-gray.svg'
// import { Link } from 'react-router-dom';
// import { useToggle } from '../../../../../context/toggle/toggleBtn';
// import { useLocation } from 'react-router-dom';
// import logger from '../../../../../utils/logger';
// import './menuList.css'
// import { ListComponent } from './ListComponent';


// export const MenuList = () => {
//   const location = useLocation()
//     // logger.debug('location SIDEMENU is: ', location.pathname.replace(/^\/+/, ""))


//   const menuOption = JSON.parse(localStorage.getItem('menuOption'));
//   logger.info('menuOption: ', menuOption)

//   const defaultSelected = menuOption.find((path) => { return path.url === location.pathname.replace(/^\/+/, "") })
//     logger.debug('defaultSelected: ', defaultSelected)

//   const { toggleClose } = useToggle()
//   return (
//     <ul className="nav flex-column nav-canva">


//       {menuOption && menuOption.length > 0 ? menuOption.map((i) => {

//         return (
//           <ListComponent
//             key={i.id}
//             functionBtn={toggleClose}
//             index={i.id}
//             icon={i.icon}
//             title={i.title}
//             url={i.url}
//             defaultSelected={!defaultSelected && i.url === "Members" ? true : false}

//           />
//         )
//       }
//       ) : null
//       }



//     </ul>
//   )
// }


import bicepsSvgBlue from '../../../../../assets/biceps-blue.svg';
import bicepsSvgGray from '../../../../../assets/biceps-gray.svg'
import { Link } from 'react-router-dom';
import { useToggle } from '../../../../../context/toggle/toggleBtn';
import { useLocation } from 'react-router-dom';
import logger from '../../../../../utils/logger';
import './menuList.css'
import { ListComponent } from './ListComponent';
import { useState } from 'react';


export const MenuList = () => {
  const menuOption = JSON.parse(localStorage.getItem('menuOption'))
  const [clickedBtn, setClickedBtn] = useState(1)
  const location = useLocation()

  // 🔹 rutas hijas → menú padre
  const ROUTE_PARENT_MAP = {
    FormationsDetail: 'Formations',
    FormationInfo: 'Formations',
  }

  const pathname = location.pathname.replace(/^\/+/, '')
  const basePath = pathname.split('/')[0]

  const resolvedMenu =
    ROUTE_PARENT_MAP[basePath] || basePath

  const menuUrls = menuOption.map(item => item.url)

  // 🔥 menú activo REAL (una sola verdad)
  const activeMenu = menuUrls.includes(resolvedMenu)
    ? resolvedMenu
    : 'Members'


    const { toggleClose } = useToggle()

  const functionBtn = (e) => {
    const selectedBtn = Number(e.currentTarget.dataset.id)
    setClickedBtn(selectedBtn)
    toggleClose()
  }
  return (
    <ul className="nav flex-column nav-canva">


      {menuOption && menuOption.length > 0 ? menuOption.map((i) => {

        return (
          <ListComponent
            key={i.id}
            index={i.id}
            icon={i.icon}
            title={i.title}
            url={i.url}
            functionBtn={functionBtn}
            isActive={i.url === activeMenu}

          />
        )
      }
      ) : null
      }



    </ul>
  )
}
